import { environment } from './../../../../environments/environment';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Component, OnInit, Input, Output, ViewChild, Inject, EventEmitter } from '@angular/core';
import { CustomersFilters } from '../../../model/customers';
import { DxDataGridComponent } from 'devextreme-angular';
import { CountryISO, SearchCountryField } from 'ngx-intl-tel-input';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CustomersService } from '../../../services/customers.service';
import { TrailerService } from '../../../services/trailers.service';
import { TrucksService } from '../../../services/trucks.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { AttachmentsService } from '../../../services/attachments.service';
import { SetupDataService } from '../../../services/setupdata.service';
import { AttachmentsComponent } from '../../theme/attachments/attachments.component';
import { MatStepper } from '@angular/material/stepper';
import { TrucksFilters } from '../../../model/trucks';
import { DriversService } from '../../../services/driver.service';
import { DispatcherService } from '../../../services/dispatcher.service';
import { FuelcardService } from '../../../services/fuelcard.service';
import { DecimalPipe } from '@angular/common';
import { VendorService } from '../../../services/vendor.service';
import moment from 'moment';
import { DriverFilters } from '../../../model/driver';
import ArrayStore from 'devextreme/data/array_store';


@Component({
  selector: 'app-driver-creation-popup',
  templateUrl: './driver-creation-popup.component.html',
  styleUrls: ['./driver-creation-popup.component.scss'],
  providers: [CustomersService, TrucksService, TrailerService, DriversService, SetupDataService]
})
export class DriverCreationPopupComponent implements OnInit{
  pageFilters :any = { fullName: "" };
  Driverlistdata = new Array<DriverFilters>();
  payratedata = [];
  drugandmedicaldata = [];
  @Input() datatype;
  // @Input() data;
  @Input() disableClose;
  @Output() newItemEvent = new EventEmitter<string>();
  // @ViewChild(DxDataGridComponent, { static: false }) grid_payrate: DxDataGridComponent;
  @ViewChild('grid_payrate',{ static: false ,read: DxDataGridComponent}) grid_payrate: DxDataGridComponent;
  @ViewChild('grid_medical',{ static: false ,read: DxDataGridComponent}) grid_medical: DxDataGridComponent;
  mode = false;
  finalArry = [];
  typeDetails = [];
  resultDetails = [];
  showAddOption = false;
  submitted: boolean;
  pageFiltersshow = false;
  payrateinfodata = {};
  drugdata = {};
  fileArray = [];
  base64FileArray = [];
  item = "";
  filedata = {};
  showviewedit = false;
  selectedDriver = true;
  showupdate = false;
  showsubmit = false;
  changeUplaod = true;
  editFileList = [];
  btnHide = false;
  DriverlistdataId;
  driverForm: FormGroup;
  SearchCountryField = SearchCountryField;

  CountryISO = CountryISO;
  preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.India];
  selectedCellPhoneCountry = "US";
  selectedEmergencyPhoneCountry = "US";
  dsPayRate: ArrayStore;
  todayDate;
  driverId;
  submittedLast = false;
  constructor(
    public dialogRef: MatDialogRef<DriverCreationPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _driverService: DriversService,
    private _trailersService: TrailerService,
    private _trucksservice: TrucksService,
    private _toaster: ToastrService,
    private router: Router,
    public dialog: MatDialog,
    private _attachementService: AttachmentsService
  ) { }
  showGoogleAddress = "";
  ngOnInit() {
    this.todayDate = new Date().toLocaleDateString("sv");
    if (this.data ==null || this.data["EditMode"] == undefined) {
      this.mode = true;
      this.showAddOption = true;
      this.selectedDriver = false;
      this.showsubmit = true;
      this.pageFilters["address"] = {};
      this.pageFilters["account"] = {};
      
      this.pageFilters["payType"] = ""
      this.pageFilters["payFrom"] = ""
      this.pageFilters["payrate"] = ""
    } else {
      this.mode = this.data["EditMode"];
      this.pageFilters = this.data;
      this.showAddOption = this.data["EditMode"];
      this.drugandmedicaldata = this.data.drugData;
      this.payratedata = this.data.payRate;
      this.changeUplaod = false;
      this.fileArrayLocal = this.data["files"];

      if(this.pageFilters["dob"] != undefined || this.pageFilters["dob"] != null){
        this.pageFilters["dob"] = moment(this.pageFilters["dob"]).format("YYYY-MM-DD");
      }
      if(this.pageFilters["hireDate"] != undefined || this.pageFilters["hireDate"] != null){
        this.pageFilters["hireDate"] = moment(this.pageFilters["hireDate"]).format("YYYY-MM-DD");
      }
      if(this.pageFilters["terminationDate"] != undefined || this.pageFilters["terminationDate"] != null){
        this.pageFilters["terminationDate"] = moment(this.pageFilters["terminationDate"]).format("YYYY-MM-DD");
      }
      if(this.pageFilters["cdlExpiryDate"] != undefined || this.pageFilters["cdlExpiryDate"] != null){
        this.pageFilters["cdlExpiryDate"] = moment(this.pageFilters["cdlExpiryDate"]).format("YYYY-MM-DD");
      }
      if(this.pageFilters["medicalCardExpiration"] != undefined || this.pageFilters["medicalCardExpiration"] != null){
        this.pageFilters["medicalCardExpiration"] = moment(this.pageFilters["medicalCardExpiration"]).format("YYYY-MM-DD");
      }
      if (this.data["EditMode"]) {
        this.showupdate = true;
        this.editFileList = this.data["files"];
      }
      if (this.data["cellPhone"] != undefined) {
        this.selectedCellPhoneCountry = this.data["cellPhone"]["countryCode"];
      }
      if (this.data["emergencyPhone"] != undefined) {
        this.selectedEmergencyPhoneCountry = this.data["emergencyPhone"]["countryCode"];
      }
      if (this.data["googleAddress"] != undefined) {
        this.showGoogleAddress = this.data["googleAddress"]["fullAddress"];
      }

    }
    this.dsPayRate = new ArrayStore({
      data: this.payratedata
    });
    this.pageFiltersshow = true;
    this.typeDetails = [
      // {
      //   ID: 0,
      //   Name: "Per Hour",
      // },
      {
        ID: 1,
        Name: "Per Mile",
      },
      {
        ID: 2,
        Name: "Percentage(%)",
      },
    ];
    this.resultDetails = [
      {
        ID: 0,
        Name: "Pass",
      },
      {
        ID: 1,
        Name: "Fail",
      },
    ];
  }

  filesChanged = false;
  fileArrayLocal = [];
  attachementData = {};

  goBack() {
    this.dialogRef.close(null);
  }


  openAttachments() {
    this.attachementData["fileInfo"] = this.fileArrayLocal;
    if (this.showsubmit || this.showupdate) {
      this.attachementData["mode"] = true;
    }
    this.attachementData["model"] = "Driver";
  }
  googleAddress;
  getGoogleAddress($event) {
    this.googleAddress = $event
    console.log(this.googleAddress);
  }
  selectedItemKeys;
  onSaved(e: any) {
    console.log(e);
    const change = e.changes;

    if (change) {
      e.cancel = true;
    }
  }

  ondrugAdd(eventName) {
    console.log(eventName.key);
    this.drugdata = eventName.key;
  }
  ondrugDelete(eventName) {
    console.log(eventName.key);
    this._driverService.DeleteDrivers(eventName.key).subscribe((data) => {
      console.log(data);
    });
  }
  ondrugEdit(eventName) {
    console.log(eventName.key);
    this.drugdata = eventName.key;
  }
  driverTestfile;
  choosen;
  addfiles(e) {
    if (e.target.value) {
      this.driverTestfile = <File>e.target.files[0];
      this.choosen = true;
    }
  }
  handleReaderLoaded(e, name) {
    this.item = "";
    var string = btoa(e.target.result);
    this.item = "data:application/vnd.ms-excel;base64," + string;
    var obj = {};
    obj["file"] = this.item;
    this.base64FileArray.push(obj);
  }

  onView(data) {
    let baseUrl = this.filedata["base_url"];
    let url = baseUrl + data.fileName;
    window.open(url, "_blank");
  }
  ondelete(data) {
    this.finalArry.splice(data, 1);
  }
  update(driverForm, stepper) {
    this.submitClicked = true;
    this.grid_medical.instance.saveEditData();
    this.grid_payrate.instance.saveEditData();
    console.log(driverForm);
    if (driverForm.valid) {
      this.data["files"] = this.fileArrayLocal;
      this.data["payRate"] = this.dsPayRate.createQuery().sortBy("__KEY__").toArray();
      this.data["drugData"] = this.drugandmedicaldata;

      if (this.googleAddress != undefined) {
        this.data["googleAddress"] = this.googleAddress;
      }
      console.log(this.data);
      if(this.data["_id"] != undefined) {
        this.driverId = this.data["_id"];
      }
      else{
        this.data["_id"] = this.driverId;
      }
      this.btnHide = true;
      delete this.data["createdAt"];
      delete this.data["updatedAt"];
      delete this.data["EditMode"];


      this._driverService.EditDrivers(this.data, this.data["_id"]).subscribe(
        (res) => {
          if (res.Status == "error") {
            this._toaster.error(res.error, "Failed", { timeOut: 1000 });
            this.btnHide = false;
            this.data["_id"] = this.driverId;
          } else {
            this._toaster.info("Driver Data Updated successfully", "Success", {
              timeOut: 1000,
            });
            this.btnHide = false;
            this.data["_id"] = this.driverId;
            // this.dialogRef.close(res);
            this.goBack();
            // if(stepper.selectedIndex === stepper.steps.length-1){
            //   // this.dialogRef.close(null);
            //   this.goBack();
            // }
          }
        },
        (error) => {
          this.data["_id"] = this.driverId;
          this._toaster.error("Driver Data Not Updated", "Failed", {
            timeOut: 1000,
          });
          // this.dialogRef.close(null);
        }
      );
    } else {
      /* this._toaster.error("Please fix the validations", "Failed", {
        timeOut: 1000,
      }); */
      this.onFromValidation(driverForm.controls);
    }
  }
  addRowPayrate(){
    this.grid_payrate.instance.addRow();
    this.grid_payrate.instance.deselectAll();
  }
  addRowMedical(){
    this.grid_medical.instance.addRow();
    this.grid_medical.instance.deselectAll();
  }
  onChangeDate(event, formData){
    Object.keys(formData.controls).forEach((key) => {
      switch (key) {
        case 'dob':
          if(new Date(formData.controls[key].value) > new Date(this.todayDate)){
            formData.controls[key].setErrors({dateError: "invalid date"});
          }
          break;
        case 'hireDate':
          if(new Date(formData.controls[key].value) > new Date(this.todayDate)){
            formData.controls[key].setErrors({dateError: "invalid date"});
          }
          break;
        case 'terminationDate':
          if(new Date(formData.controls[key].value) < new Date(this.todayDate)){
            formData.controls[key].setErrors({dateError: "invalid date"});
          }
          break;
        case 'cdlExpiryDate':
          if(new Date(formData.controls[key].value) < new Date(this.todayDate)){
            formData.controls[key].setErrors({dateError: "invalid date"});
          }
          break;
        case 'medicalCardExpiration':
          if(new Date(formData.controls[key].value) < new Date(this.todayDate)){
            formData.controls[key].setErrors({dateError: "invalid date"});
          }
          break;

        default:
          break;
      }
    })
  }
  reset() { }
  submitClicked = false;

  submit(driverForm) {
    this.submitClicked = true;
    this.grid_payrate.instance.saveEditData();
    if (driverForm.valid) {
      this.submitted = true;
      var Driverlistdata: any = this.pageFilters;
      Driverlistdata["payRate"] = this.dsPayRate.createQuery().sortBy("__KEY__").toArray();
      Driverlistdata["drugData"] = this.drugandmedicaldata;
      Driverlistdata["companyid"] = localStorage.selectedCompany;
      // var idArry = [];
      // for (var i = 0; i < this.finalArry.length; ++i) {
      //   idArry.push(this.finalArry[i].name);
      // }
      // if (idArry.length > 0) {
      //   Driverlistdata["files"] = idArry;
      // }
      Driverlistdata["files"] = this.fileArrayLocal;
      this.btnHide = true;
      this.pageFilters["companyId"] = localStorage.getItem("selectedCompany");
      console.log(this.pageFilters["companyId"]);

      var addobj = {};
      addobj["line"] = Driverlistdata["address"]["line"];
      addobj["line1"] = Driverlistdata["address"]["line1"];
      addobj["city"] = Driverlistdata["address"]["city"];
      addobj["state"] = Driverlistdata["address"]["state"];
      addobj["zip"] = Driverlistdata["address"]["zip"];
      addobj["country"] = Driverlistdata["address"]["country"];
      delete Driverlistdata["line"];
      delete Driverlistdata["line1"];
      delete Driverlistdata["city"];
      delete Driverlistdata["state"];
      delete Driverlistdata["zip"];
      delete Driverlistdata["country"];
      Driverlistdata["address"] = addobj;

      if (this.googleAddress != undefined) {
        Driverlistdata["googleAddress"] = this.googleAddress;
      }
      var account = {};
      account["bankname"] = Driverlistdata["account"]["bankname"];
      account["accountnumber"] = Driverlistdata["account"]["accountnumber"];
      account["acctype"] = Driverlistdata["account"]["acctype"];

      delete Driverlistdata["accountnumber"];
      delete Driverlistdata["bankname"];
      delete Driverlistdata["acctype"];
      delete Driverlistdata["companyid"];
      delete Driverlistdata["payType"];
      delete Driverlistdata["payrate"];
      delete Driverlistdata["payFrom"];

      Driverlistdata["account"] = account;
      Driverlistdata["_id"] = this.DriverlistdataId;
      this.submittedLast = true;
      
        this.btnHide = true;
        this._driverService.SendForm(Driverlistdata).subscribe(
          (response) => {
            if (response.Status == "error") {
              this._toaster.error(response.error, "Failed", {
                timeOut: 1000,
              });
              this.btnHide = false;
              this.submittedLast = false;
            } else {
              this.submittedLast = true;
              this._toaster.info("Driver Data Submitted", "Success", {
                timeOut: 1000,
              });
              this.btnHide = false;
              this.DriverlistdataId = response["result"]["_id"];
              console.log(this.DriverlistdataId);
              this.dialogRef.close(response);
              // this.goBack();
            }
          },
          (error) => {
            this.submittedLast = false;
            let resError = JSON.parse(error?._body).error;
            if(resError){
              this._toaster.error(resError.details[0].message, "Failed", {
                timeOut: 1000,
              });
            }
            else{
                this._toaster.error("Submit Again", "Failed", { timeOut: 1000 });
            }
          }
        );
        // this.goBack();
      
    } else {
      /* this._toaster.error("Please fix the validations", "Failed", {
        timeOut: 1000,
      }); */
      this.onFromValidation(driverForm.controls)
    }
  }
  onFromValidation(formData) {
    console.log(formData);
    let check = false;
    let timeout = 3000;
    Object.keys(formData).forEach((key) => {
      if (check) {
        return;
      }
      if (formData[key].errors) {
        if (key === "fullName") {
          this._toaster.error("Full Name is Required", "Failed", {
            timeOut: timeout,
          });
          check = true;
        } else if (key === "cellPhone") {
          if(formData[key].errors.validatePhoneNumber){
            this._toaster.error("Cell phone is invalid", "Failed", {
              timeOut: timeout,
            });
            check = true;
          }
          else if(formData[key].errors.required){
            this._toaster.error("Cell phone is Required", "Failed", {
              timeOut: timeout,
            });
            check = true;
          }
        } else if (key === "emergencyPhone") {
          if(formData[key].errors.validatePhoneNumber){
            this._toaster.error("Emergency phone is invalid", "Failed", {
              timeOut: timeout,
            });
            check = true;
          }
          else if(formData[key].errors.required){
            this._toaster.error("Emergency phone is Required", "Failed", {
              timeOut: timeout,
            });
            check = true;
          }
        } else if (key === "email" && this.pageFilters.allowAccess) {
          if (formData[key].errors.pattern) {
            this._toaster.error(
              "Email ID is invalid",
              "Failed",
              {
                timeOut: timeout,
              }
            );
            check = true;
          } else if (formData[key].errors.required ) {
            this._toaster.error("Email address is required", "Failed", {
              timeOut: timeout,
            });
            check = true;
          }
        }
        else if(key === "dob") {
          this._toaster.error("Please enter a valid date of birth ", "Failed", {
            timeOut: timeout,
          });
          check = true;
        }
        else if(key === "ssn") {
          this._toaster.error("SSN only number are allowed ", "Failed", {
            timeOut: timeout,
          });
          check = true;
        }
        else if(key === "hireDate") {
          this._toaster.error("Please enter a valid hire date ", "Failed", {
            timeOut: timeout,
          });
          check = true;
        }
        else if(key === "terminationDate") {
          this._toaster.error("Please enter a valid termination date ", "Failed", {
            timeOut: timeout,
          });
          check = true;
        }
        else if(key === "vendorAccount") {
          this._toaster.error("Vendor ID Account only Alphanumeric values are allowed", "Failed", {
            timeOut: timeout,
          });
          check = true;
        }
        else if(key === "accountnumber") {
          this._toaster.error("Accounts Number - only numbers are allowed", "Failed", {
            timeOut: timeout,
          });
          check = true;
        }
        else if(key === "routingNumber") {
          this._toaster.error("Routing Number - only numbers are allowed", "Failed", {
            timeOut: timeout,
          });
          check = true;
        }
        else if(key === "cdlNumber") {
          this._toaster.error("CDL Number - only numbers are allowed", "Failed", {
            timeOut: timeout,
          });
          check = true;
        }
        else if(key === "cdlExpiryDate") {
          this._toaster.error("Please enter a valid cdl expiry date ", "Failed", {
            timeOut: timeout,
          });
          check = true;
        }
        else if(key === "medicalCardExpiration") {
          this._toaster.error("Please enter a valid medical card expiration date ", "Failed", {
            timeOut: timeout,
          });
          check = true;
        }
        else if(key === "yearsOfExperience") {
          this._toaster.error("Year of Experience - only numbers are allowed", "Failed", {
            timeOut: timeout,
          });
          check = true;
        }
        else {
          this._toaster.error("Please fix the validations", "Failed", {
            timeOut: 1000,
          });
          check = true;
        }
      }
    });
  }
  hidePopup() {
    if (this.submitted) {
      this.submitClicked = false;
      // this.dialogRef.close(true);
    } else {
      let companyName = localStorage
        .getItem("selectedCompanyName")
        .toLowerCase()
        .split(" ")
        .join("_");
      let formName = "Driver";
      if (this.filesChanged) {
        if (this.showsubmit) {
          this.fileArrayLocal.forEach((item, index) => {
            // if (item.fileName === fileName) this.fileInfo.splice(index, 1);
            this._attachementService
              .deleteFile(companyName, formName, item.fileName)
              .subscribe(
                (response) => { },
                (err) => {
                  this._toaster.error("Files deletion failed.", "Failed", { timeOut: 1000 });
                }
              );
          });
        }
        else if (this.update) {
          let obj = {};
          obj["files"] = this.fileArrayLocal;
          this._driverService.EditDrivers(obj, this.data["_id"]).subscribe(
            (res) => {
              if (res.Status == "error") {
                this._toaster.error(res.error, "Failed", { timeOut: 1000 });
                this.btnHide = false;
              } else {
                this.btnHide = false;
                // this.dialogRef.close(res);
              }
            },
            (error) => {
              this._toaster.error("Driver Data Not Updated", "Failed", {
                timeOut: 1000,
              });
              // this.dialogRef.close(null);
            }
          );
        }
      }
      // this.dialogRef.close(null);
    }
  }
}
